/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { inventoryStore } from '../../axios/inventoryStore'
import type {
	InventoryStoreError,
	InventoryStorePathParams,
	InventoryStoreRequest,
	InventoryStoreResponse,
} from '../../types/InventoryStore'

export const inventoryStoreMutationKey = () => [{ url: '/:organisation/inventory' }] as const

export type InventoryStoreMutationKey = ReturnType<typeof inventoryStoreMutationKey>

export type InventoryStoreVariables = {
	organisation: InventoryStorePathParams['organisation']
	data: InventoryStoreRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::store */
export function useInventoryStore<TContext = unknown>(
	options?: UseMutationOptions<
		InventoryStoreResponse,
		AxiosError<InventoryStoreError>,
		InventoryStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: inventoryStoreMutationKey(),
		mutationFn: ({ organisation, data }: InventoryStoreVariables) =>
			inventoryStore(organisation, data, config).then(res => res.data),
		...options,
	})
}
